/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StripeProductQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type StripeProductQuery = { __typename?: 'Query', stripeProduct?: { __typename?: 'StripeProduct', id: string, name?: string | null, default_price?: { __typename?: 'StripePrice', id: string, unit_amount: number } | null } | null };

export type GetUserSubscriptionDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetUserSubscriptionDetailsQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, isOver18?: boolean | null, isParticipatingInPrizeDraw?: boolean | null } | null };

export type UpdateUserSubscriptionDetailsMutationVariables = Types.Exact<{
  input: Types.UserUpdateInput;
}>;


export type UpdateUserSubscriptionDetailsMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, isOver18?: boolean | null, isParticipatingInPrizeDraw?: boolean | null } | null };


export const StripeProductDocument = gql`
    query stripeProduct($id: String!) {
  stripeProduct(id: $id) {
    id
    name
    default_price {
      id
      unit_amount
    }
  }
}
    `;

/**
 * __useStripeProductQuery__
 *
 * To run a query within a React component, call `useStripeProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStripeProductQuery(baseOptions: Apollo.QueryHookOptions<StripeProductQuery, StripeProductQueryVariables> & ({ variables: StripeProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeProductQuery, StripeProductQueryVariables>(StripeProductDocument, options);
      }
export function useStripeProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeProductQuery, StripeProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeProductQuery, StripeProductQueryVariables>(StripeProductDocument, options);
        }
export function useStripeProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StripeProductQuery, StripeProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeProductQuery, StripeProductQueryVariables>(StripeProductDocument, options);
        }
export type StripeProductQueryHookResult = ReturnType<typeof useStripeProductQuery>;
export type StripeProductLazyQueryHookResult = ReturnType<typeof useStripeProductLazyQuery>;
export type StripeProductSuspenseQueryHookResult = ReturnType<typeof useStripeProductSuspenseQuery>;
export type StripeProductQueryResult = Apollo.QueryResult<StripeProductQuery, StripeProductQueryVariables>;
export const GetUserSubscriptionDetailsDocument = gql`
    query GetUserSubscriptionDetails($id: ID!) {
  user(id: $id) {
    id
    isOver18
    isParticipatingInPrizeDraw
  }
}
    `;

/**
 * __useGetUserSubscriptionDetailsQuery__
 *
 * To run a query within a React component, call `useGetUserSubscriptionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSubscriptionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSubscriptionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSubscriptionDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables> & ({ variables: GetUserSubscriptionDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables>(GetUserSubscriptionDetailsDocument, options);
      }
export function useGetUserSubscriptionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables>(GetUserSubscriptionDetailsDocument, options);
        }
export function useGetUserSubscriptionDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables>(GetUserSubscriptionDetailsDocument, options);
        }
export type GetUserSubscriptionDetailsQueryHookResult = ReturnType<typeof useGetUserSubscriptionDetailsQuery>;
export type GetUserSubscriptionDetailsLazyQueryHookResult = ReturnType<typeof useGetUserSubscriptionDetailsLazyQuery>;
export type GetUserSubscriptionDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUserSubscriptionDetailsSuspenseQuery>;
export type GetUserSubscriptionDetailsQueryResult = Apollo.QueryResult<GetUserSubscriptionDetailsQuery, GetUserSubscriptionDetailsQueryVariables>;
export const UpdateUserSubscriptionDetailsDocument = gql`
    mutation UpdateUserSubscriptionDetails($input: UserUpdateInput!) {
  updateUser(input: $input) {
    id
    isOver18
    isParticipatingInPrizeDraw
  }
}
    `;
export type UpdateUserSubscriptionDetailsMutationFn = Apollo.MutationFunction<UpdateUserSubscriptionDetailsMutation, UpdateUserSubscriptionDetailsMutationVariables>;

/**
 * __useUpdateUserSubscriptionDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSubscriptionDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSubscriptionDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSubscriptionDetailsMutation, { data, loading, error }] = useUpdateUserSubscriptionDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSubscriptionDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSubscriptionDetailsMutation, UpdateUserSubscriptionDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSubscriptionDetailsMutation, UpdateUserSubscriptionDetailsMutationVariables>(UpdateUserSubscriptionDetailsDocument, options);
      }
export type UpdateUserSubscriptionDetailsMutationHookResult = ReturnType<typeof useUpdateUserSubscriptionDetailsMutation>;
export type UpdateUserSubscriptionDetailsMutationResult = Apollo.MutationResult<UpdateUserSubscriptionDetailsMutation>;
export type UpdateUserSubscriptionDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSubscriptionDetailsMutation, UpdateUserSubscriptionDetailsMutationVariables>;